import { useDictionary } from 'lib/utils';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import { Text, Image, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';
import { HostDetails, HostsProps } from 'models/podcasts-types';
import styles from './SeasonDetail.module.scss';

const cx = classNames.bind(styles);

const Hosts: React.FC<HostsProps> = (props) => {
  const { sitecoreContext } = useSitecoreContext();
  const { fallbackHosts, personFallbackImage, hostsTextPluralOverride, hostsTextSingularOverride } = props;
  let { hosts } = props;

  let hostsTitleSingular = useDictionary('About the host');
  let hostsTitleMultiple = useDictionary('About the hosts');

  hostsTitleSingular = hostsTextSingularOverride ? hostsTextSingularOverride : hostsTitleSingular;
  hostsTitleMultiple = hostsTextPluralOverride ? hostsTextPluralOverride : hostsTitleMultiple;

  if (hosts?.length === 0 && fallbackHosts) {
    hosts = fallbackHosts;
  }

  if (hosts?.length === 0) {
    return <></>;
  }

  const hostsTitle = hosts?.length > 1 ? hostsTitleMultiple : hostsTitleSingular;

  return (
    <div className={cx('bio-listing', 'bio-listing-no-pad')}>
      <Text field={{ value: hostsTitle }} tag="h2" className={cx({ title: true })} />

      {hosts?.map((item: HostDetails, index: number) => (
        <div className={cx('bio-listing-item', 'hosts-padding')} key={index} attr-data-type="bio-item">
          {(item.fields.image?.value?.src || personFallbackImage?.value?.src) && (
            <div className={cx('bio-listing-item-photo')}>
              <Image
                field={item.fields.image?.value?.src ? item.fields.image : personFallbackImage}
                className={cx('listing-image-column__image')}
              />
            </div>
          )}

          <div className={cx('bio-listing-item-info')}>
            <h3 className={cx('mb-2', 'mt-1', 'bio-listing-title')}>{item.fields.name?.value || item.name}</h3>
            {item?.fields?.bioTitles?.length > 0 &&
              item?.fields?.bioTitles?.map((title, index) => (
                <h4 key={index}>
                  <Text field={title.fields?.Value} editable={false} encode={sitecoreContext.pageEditing} />
                </h4>
              ))}

            <RichTextWrapper field={item.fields?.bio} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Hosts;
